<template>
  <div class="fill-height">
    <div class="container">
     
     <div class="mobfilter" v-if="window.width <= 480">
       <span class="text-center">Filters</span>
       <div class="filterarrow" @click="showallfilter()">
        <span class="material-icons" v-if="!mobfiltershow">keyboard_arrow_down</span>
        <span class="material-icons" v-else>keyboard_arrow_up</span>
       </div>
     </div>
     <div class="filter" v-show="mobfiltershow">
      <div>
          <v-select  :items="categories" @change="getSubcat()" item-text="name" item-value="id" label="Choose Section" v-model="selectedcategory" hide-details outlined></v-select>
        </div>
        <div>
          <v-select  :items="subcategories" item-text="name" item-value="id" label="Choose Category" v-model="selectedsubcategory" hide-details outlined></v-select>
        </div>
        <div>
          <v-text-field label="Search by keyword" name="search" outlined  type="text" hide-details  v-model="search"/>
        </div>
        <div>
          <v-select  :items="filters" item-text="name" item-value="id" label="Choose Criteria" v-model="selectedfilter" hide-details outlined></v-select>
        </div>
        <div>
           <v-btn @click="filter()" color="black" class="white--text">Search</v-btn>
        </div>
     </div>
     <div class="question-list" v-if="questions.length > 0">
        <div v-for="(val,key) in questions" :key="key">
          <div  class="question-block">
          <!--
           <div class="showamount">
             <div class="items">
               <div class="makeitbtn"><span>${{ val.amount }}</span> <span>K{{ val.kels }}</span></div>
             </div>
             <div class="items">
               <v-btn class="potamnt" color="secondary">
                <span>${{ val.potamount }}</span> <span>K{{ val.potkels }}</span>
               </v-btn>
            </div>
           </div>
          -->
           <div class="qtn">Q. {{ val.question }}</div>
           <div class="actiontab">
              <div class="countdown firstchild">
                 <v-avatar v-if="val.user_avatar != ''" class="myavatar mr-1" size="50px"><img alt="Avatar" :src="val.user_avatar" ></v-avatar>
                 <v-avatar v-else class="myavatar mr-1" size="50px"><img alt="Avatar" :src="avatar" ></v-avatar>
                 <img width="30px" :title="val.level.level" :src="val.level.level_image"/>
              </div>
              <div class="secondchild">
                 <!--
                <v-btn class="mybtn" :to="getLink(val.id)" color="primary" v-if="val.answered == 0">
                   <span v-if="val.completed == 0">Answer this <br/> question</span>
                   <span v-else>View Answer</span>
                </v-btn>
                -->
                <div class="mt-2 mb-1 text-center">
                  <flip-countdown  @timeup="markExpired(key)" v-if="val.completed == 0"  :labels="{days: 'D',hours: 'H',minutes: 'M',seconds: 'S'}" :deadline=val.endtime></flip-countdown>
                </div>
                <v-btn class="mybtn" :to="getLink(val.id)" color="primary" v-if="val.answered == 0 && val.completed == 0">
                   <span>Answer this <br/> question</span>
                </v-btn>
                <v-btn class="mybtn"   @click="toggleExpand(key)"  color="secondary" v-else>
                   <span>View Answer</span>
                </v-btn>
              </div>
              <div class="thirdchild">
               <!-- <div class="showansavatar" v-if="val.displayvote.length > 0">
                   <div class="smallava" v-for="(value,key) in val.displayvote" :key="key">
                      <img :src="value" />
                   </div>
                </div>-->
                
                  <div class="remainvotes">{{ val.totalvote }} votes</div>
              </div>
           </div>
           <transition name="expand">
            <div v-show="expandedIndex === key" class="expand-section">
              <div class="makefullnew" v-for="(vals,key) in val.options" :key="key" >
                <div>{{ vals }} </div>
                <div>
                  <v-progress-linear 
                      :color=val.percentagecol[key]
                      rounded
                      :value=val.percentage[key]
                      height="15">
                      <span class="progress-bar-txt">{{ val.percentage[key] }}%</span>
                  </v-progress-linear>
                </div>
              </div>
             </div>
            </transition>
          </div>
          <div v-if="((key + 1) % 3 === 0 && key > 0) || (key + 1 === questions.length)"  class="advertise">
                <div class="adcontainer" v-if="!showpreviewbanner">
                  <iframe
                    src="https://api.damnnbank.com/api/showbanners?website=myvoco&width=700&height=90"
                    frameborder="0"
                    scrolling="no"
                    width="720"
                    height="90"
                    allow="autoplay"
                  ></iframe>
                </div>
                <div class="adcontainer" v-else>
                  <iframe
                    ref="myIframe"
                    :src="iframeurl"
                    frameborder="0"
                    scrolling="no"
                    width="720"
                    height="90"
                    allow="autoplay"
                  ></iframe>
                </div>
             </div>
        </div>
     </div>
     <div class="question-list nodata" v-else>
        <div class="mb-10">No Questions Available Right Now</div>
        <div class="adcontainer" v-if="!showpreviewbanner">
                <iframe  src='https://api.damnnbank.com/api/showbanners?website=myvoco&width=700&height=90' frameborder='0' scrolling='no' width='720' height='90' allow='autoplay'></iframe>
              </div>
              <div class="adcontainer" v-else>
                <iframe ref="myIframe" :src=iframeurl frameborder='0' scrolling='no' width='720' height='90' allow='autoplay'></iframe>
              </div>
      </div>
  </div>
  <v-dialog transition="dialog-bottom-transition" max-width="300" v-model="dialog">
      <v-card>
        <v-toolbar color="primary" dark>Alert</v-toolbar>
        <v-card-text>
          <div class="mt-5 message">{{ message }}</div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="closedialog()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <Loading :displayDialog="showdialog" />
</div> 
</template>
<script>
import { getUserTimezone } from '../plugins/timezone';
import Loading from '../components/Loader.vue';
import FlipCountdown from 'vue2-flip-countdown'

export default {
    name: 'Category',
    components:{
      Loading,
      FlipCountdown
    },
    data()
    {
      return{
        mobfiltershow:true,
        showfilter:false,
        showdialog:false,
        categories:[],
        subcategories:[],
        questions:[],
        category:0,
        search:'',
        selectedcategory:0,
        selectedsubcategory:0,
        filters:[{'id':'most votes','name':'Most Votes'},{'id':'latest question','name':'Latest Question'},{'id':'ending soon','name':'Ending Soon'}],
        selectedfilter:'',
        dialog:false,
        message:'',
        window: {width: 0,height: 0},
        showpreviewbanner:false,
        expandedIndex: null,
        avatar: require("@/assets/avatar.png"),
      }
    },
    watch:{
        $route(){
          this.handleResize();
         }   
    },
    created(){
       if(typeof this.$route.query.preview != "undefined")
    {
       let id = this.$route.query.preview;
       this.showpreviewbanner = true;
       this.iframeurl = 'https://api.damnnbank.com/api/bannerpreview/'+id;
       //this.$refs.myIframe.scrollIntoView({ behavior: 'smooth' })
    }
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      this.showdialog = true;
      if(typeof this.$route.params.category != "undefined")
      {
         this.category = this.$route.params.category;   
      }
      this.getCategories();
      this.getQuestions();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
      markExpired(index) {
      this.$set(this.questions[index], 'expired', true);
    },
       toggleExpand(index) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  },
      handleResize() 
        {
          
           this.window.width = window.innerWidth;
           this.window.height = window.innerHeight;
           
           if(this.window.width <= 480)
           {
             this.mobfiltershow = false;
           }
           else
           {
            this.mobfiltershow = true;
           }
      }, 
      showallfilter(){
         this.mobfiltershow =! this.mobfiltershow;
      },   
      getLink(id){
         let value = '/question/'+id; 
         return value;
      },
      closedialog(){
          this.dialog = false;
          this.message = '';
      },
      getCategories(){
        this.$store.dispatch("getcategories").then((response) => 
        {
           this.categories = [{id:'',name:"Choose Section"}]; 
           if(response.data.length > 0)
           {
            for(var i = 0; i < response.data.length; i++)
             {
               this.categories.push({ id:response.data[i].id, name:response.data[i].name });
             }     
           }
        });
      },
      getSubcat(){
        this.$store.dispatch("getSubcategory",{category:this.selectedcategory}).then((response) =>{
            this.subcategories = response.data;  
        });
      },
      filter(){
         if(this.search == '' && this.selectedcategory == 0 && this.selectedsubcategory == 0)
         {
           this.message = "Choose category or enter something to search";
           this.dialog = true;
         } 
         else
         {
           this.showdialog = true;
           this.getQuestions();
         }
      },
      getQuestions()
      {
         var category    = this.category; 
         var subcategory = this.selectedsubcategory;
         var keyword     = this.search;
         var sortyby     = this.selectedfilter;
         const userTimezone = getUserTimezone();   

         if(this.selectedcategory > 0) 
         {
           var findarrIndex       = this.categories.findIndex(p => p.id == this.selectedcategory); 
           category = this.categories[findarrIndex].name; 
         } 
         this.questions = [];
         this.$store.dispatch("getQuestions",{category:category,subcategory:subcategory,keyword:keyword,sortyby:sortyby, timezone: userTimezone}).then((response) => 
         {
             if(response.data.length > 0)
             {
               this.questions = response.data;
             }
             this.showdialog = false;
         });
      },
    }
}          
</script>
<style scoped>
.mobfilter{border-radius: 8px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 15px; font-weight: bold;    width: 100%;  position: relative;}
.mobfilter > span {  display: block;  text-transform: uppercase;}
.filterarrow {  position: absolute;  right: 8px;  top: 14px;}
.filter{display: flex; align-items: center; border-radius: 8px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 15px; margin-bottom: 25px; margin-top: 10px;}
.filter > div{margin-right: 10px; margin-top: 5px; margin-bottom: 5px;}
.filter div:nth-child(1){ flex: 0 0 21%; }
.filter div:nth-child(2){ flex: 0 0 21%; }
.filter div:nth-child(3){ flex: 0 0 21%; }
.filter div:nth-child(4){ flex: 0 0 21%; }
.filter div:nth-child(5){ flex: 0 0 12%; text-align: center;} 
.nodata{text-align: center; font-weight: bold; margin-top: 50px;}
.question-block{min-height: 65px; padding: 15px; margin-top: 15px; border-radius: 8px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;}
.actiontab{margin-top: 15px;text-align: center; display: flex; align-items: center;}
.actiontab div.secondchild{flex: 0 0 33%; text-align: center;}
.actiontab div.firstchild{flex: 0 0 33%; 
 display: flex;          /* Make it a flex container */
  align-items: center;    /* Vertically center avatar + star */
  justify-content: left;/* Horizontally center them */
  gap: 8px;             }
.actiontab div.thirdchild{text-align: left; flex: 0 0 33%;}
.actiontab div.thirdchild {display: flex; align-items: center; flex-direction: column;}
.actiontab-item span{margin-right: 5px;}
.actiontab-item:nth-child(1) {display: block;flex-grow: 0;flex-shrink: 1;flex-basis: auto;align-self: auto;order: 0;width: 25%;}
.actiontab-item:nth-child(2) {display: block;flex-grow: 0;flex-shrink: 1;flex-basis: auto;align-self: auto;order: 0;width: 25%;text-align: right;}
.mybtn{text-align: center;}
.qtn{font-family: 'Poppins', sans-serif;}
.showansavatar {display: flex; justify-content: right;}
.remainvotes {  flex: 0 0 40%;  font-size: 13px;}
.showansavatar > div {
    flex: 0 0 25%;
    margin-right: 5px;
    border-radius: 50%;
    overflow: hidden;
}
.smallava img {
    width: 85%;
}
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
  padding: 0;
  margin: 0;
}

.expand-enter-to,
.expand-leave {
  max-height: 500px; /* adjust depending on content */
  opacity: 1;
}
.advertise{margin-top: 10px; text-align: center;}
.makefullnew{width: 50%; margin: auto; margin-top: 20px;}
 .makefullnew div{width: 100%;margin-right: 5px;}
 .myavatar{border:2px solid gray}
@media(max-width:1180px)
{
  .showamount div.items{width: 13%;}
  .actiontab div.firstchild, .actiontab div.thirdchild {flex: 0 0 25%;}
  .actiontab div.secondchild{flex: 0 0 50%;} 
} 

@media(max-width:820px)
{
  .showamount div.items{width: 15%;}
}  
@media(max-width:768px){
  .filter div{flex: 0 0 19% !important;}
  
}
@media(max-width:680px)
{
  .showamount div.items{width: 17%;}
}  
@media(max-width:480px)
{
  .filter{display: block;}
  .filter div{margin-bottom: 10px;}
  .showamount{margin-bottom:10px}
  .showamount div.items { width: 30%;}
  .question-block{padding: 10px;}
  /*.actiontab{flex-direction: column;}
  .actiontab div.firstchild{order: 2;}
  .actiontab div.secondchild{order: 1; margin-bottom: 10px;}
  .actiontab div.thirdchild{order: 3; margin-bottom: 10px; width:100%; margin-top:5px}*/
   .actiontab {
    flex-direction: row !important;   /* Always row */
    flex-wrap: nowrap;                /* Prevent wrapping */
    justify-content: space-between;   /* Spread items */
    align-items: center;              /* Vertical align */
  }

  .actiontab div.firstchild,
  .actiontab div.secondchild,
  .actiontab div.thirdchild {
    flex: 0 0 30%;        /* Keep 3 equal columns */
    text-align: center;
  }

  .actiontab div.firstchild{
    text-align: left !important;
  }

  .actiontab div.firstchild {
    display: flex;
   
    gap: 6px;             /* space between avatar + star */
  }
  .actiontab .countdown {
    transform: scale(0.8);   /* Shrinks it to 80% */
    transform-origin: center;/* Keeps it centered */
  }
 
  .showansavatar > div{flex: 0 0 15%;}
  .makefullnew{width: 100%;}
} 
@media(max-width:400px)
{
  .showamount div.items{ width: 34%;}
}  
@media(max-width:320px)
{
  .showamount div.items{ width: 40%;}
}   

</style>
<style>
.showamount{display: flex; align-items: center; justify-content: right; margin-bottom: 7px;}
.makeitbtn { width: 98%; margin: auto; padding: 6px; border-top: 2px solid #ff7325; border-bottom: 2px solid #ff7325; border-right: 4px solid #ff7325; border-left: 4px solid #ff7325; border-radius: 6px; color: #ff7325; font-size: 14px; font-weight: bold ; }
.makeitbtn span:nth-child(1){margin-right: 5px;}
.potamnt span:nth-child(1){margin-right: 5px;}
.showamount div.items{width: 10%; text-align: center;}
.showamount div.items:nth-child(2){margin-left: 10px;}
.flip-clock__slot{
    font-size: 10px !important;
}
.flip-card{
    font-size: 1.1rem !important;
}
.container.flip-clock{padding: 0 !important;}
.flip-card__top, .flip-card__bottom, .flip-card__back-bottom, .flip-card__back::before, 
.flip-card__back::after{color: #ff7325 !important;}
@media(max-width:480px){
  .actiontab div.secondchild .flip-card {
    font-size: 0.95rem !important;
  }
  
}
</style>